import * as Sentry from '@sentry/react'
import type { ErrorReporter } from '@healthshare/shared/platform/errorReporter'

/**
 * The web app's ErrorReporter: a thin pass-through to @sentry/react.
 *
 * Core code calls `getErrorReporter()` instead of importing Sentry directly, so
 * the same modules can run under @sentry/react-native in the Expo app or under a
 * partner-supplied reporter in the SDK. See docs/plans/embeddable-sdk.md.
 */
export const sentryErrorReporter: ErrorReporter = {
  captureException(error, context) {
    Sentry.captureException(error, context)
  },
  captureMessage(message, context) {
    Sentry.captureMessage(message, context)
  },
  addBreadcrumb(breadcrumb) {
    Sentry.addBreadcrumb(breadcrumb)
  },
}
